module.exports = Object.freeze({
  ONLINE: "online",
  OFFLINE: "offline",
  FOUND: "found",
  NOT_FOUND: "not-found",
});
